import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import chatService from '../services'

export function useMutationPinRoom() {
	return useMutation({
		mutationFn: ({ roomId, isPinned }: { roomId: string; isPinned: boolean }) =>
			chatService.pinRoom(roomId, isPinned),
		onSuccess: (_, variables) => {
			// SSE chat:room_pinned handles cache invalidation
			toast.success(
				variables.isPinned ? 'ปักหมุดห้องแล้ว' : 'ยกเลิกปักหมุดแล้ว',
			)
		},
		onError: () => {
			toast.error('ดำเนินการล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
